// Uniform fine-print notes shown below offers
export const LEASING_TRANSFER_COST_NOTE =
  "Überführungskosten werden gesondert berechnet.";
